import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { CircularProgress } from '@mui/material';

import { useGetAchievementSubject } from '~/hooks/apis/agent/useGetAchievementSubject';

import { AchievementListRow } from '~/types/services/agentHub';

interface Props {
  subjectType: AchievementListRow['subjectType'];
  subjectId: string;
  linked?: boolean;
}

function getSubjectHref(subjectType: AchievementListRow['subjectType'], subjectId: string) {
  const id = encodeURIComponent(subjectId);
  if (subjectType === 'agency') {
    return `/agencies/agencies?id=${id}`;
  }
  if (subjectType === 'affiliation') {
    return `/agencies/affiliations?affiliationId=${id}`;
  }
  return `/users/${id}`;
}

export default function AchievementSubjectName({ subjectType, subjectId, linked = false }: Props) {
  const { data, isFetching } = useGetAchievementSubject(subjectType, subjectId);
  const label = data?.name || '-';

  if (isFetching && !data?.name) {
    return <CircularProgress size={16} />;
  }

  if (!linked || !data?.name) {
    return <span>{label}</span>;
  }

  return <Link to={getSubjectHref(subjectType, subjectId)}>{label}</Link>;
}
